import { billingRoutes, roles } from "constant/constants";
import { hasSystemAccess, isInternalSchool } from "helper/HelperFunction";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";

// Billing pages a user who already has access should never land on: the
// packages page for anyone holding a bundle, and every billing page for an
// internal school, which has nothing to buy and no credits to top up. The
// sidebar hides these too — this covers the URL being typed or bookmarked.
const isBlockedBillingRoute = (pathname, isInternal) =>
  isInternal
    ? billingRoutes.includes(pathname)
    : pathname === "/assessment-packages";

function ProtectedRouter({ element, isProtected, permissions }) {
  const { user } = useSelector((state) => state.authReducer);
  const isAuthenticated = useSelector((state) => state.authReducer.isLogin);
  const isSubscribed = hasSystemAccess(user);
  const isInternal = isInternalSchool(user);
  const isSurveyFilled = user?.surveyFilled;

  const pathname = useLocation().pathname;

  if (!isProtected) {
    return element;
  }

  if (isProtected && !isAuthenticated) {
    return <Navigate replace to="/login" />;
  }

  if (isAuthenticated && !isProtected) {
    return <Navigate replace to="/" />;
  }
  if (isAuthenticated && isProtected) {
    // for student
    if (
      !isSurveyFilled &&
      pathname !== "/survey-form" &&
      user?.role === roles.STUDENT
    ) {
      return <Navigate replace to="/survey-form" />;
    }
    // for school admin
    if (!isSubscribed && pathname !== "/assessment-packages") {
      return <Navigate replace to="/assessment-packages" />;
    } else if (isSubscribed && isBlockedBillingRoute(pathname, isInternal)) {
      return <Navigate replace to="/" />;
    }
  }
  if (isAuthenticated && isSubscribed) {
    const hasPermission = permissions.includes(user?.role);
    if (!hasPermission) {
      return <Navigate replace to="/" />;
    }
  }
  return element;
}
export default ProtectedRouter;
